import { z } from "zod";
export const healthResponseSchema = z.object({
    checks: z
        .object({
        contentDelivery: z.enum(["ok", "unavailable"]).optional(),
        database: z.enum(["ok", "unavailable"]).optional(),
    })
        .strict()
        .optional(),
    service: z.literal("api"),
    status: z.enum(["ok", "degraded"]),
    timestamp: z.iso.datetime(),
});
//# sourceMappingURL=health.js.map